import { Box, styled } from '@withjoy/joykit';

export const StyledCardTileContainer = styled(Box)<{ $height?: number }>`
  width: 100%;
  height: 100%;
  position: relative;
  padding: 0;
`;

export const StyledCardPhoto = styled(Box)`
  width: 100%;
  height: 100%;
  background-repeat: no-repeat;
  mix-blend-mode: multiply;
  background-position: center;
  position: absolute;
  top: 0;
`;
